import { Component, OnInit } from "@angular/core"

@Component({
  standalone: false,
  selector: "app-afb-page",
  templateUrl: "./afb-page.component.html",
})
export class AfbPageComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
